














































import {
  defineComponent,
  ref,
  onMounted,
  PropType,
  watch,
} from '@vue/composition-api';
import { SearchSpellingResultRow } from '@oare/types';
import GrammarDisplay from '@/views/DictionaryWord/components/WordInfo/components/Forms/components/GrammarDisplay.vue';

export default defineComponent({
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    spelling: {
      type: String,
      required: true,
    },
    forms: {
      type: Array as PropType<SearchSpellingResultRow[]>,
      required: true,
    },
    spellingUuid: {
      type: String,
      required: false,
    },
  },
  components: {
    GrammarDisplay,
  },
  setup(props, { emit }) {
    const selectedOption = ref<SearchSpellingResultRow>();

    const setSpelling = () => {
      emit('set-spelling', selectedOption.value);
    };

    const resetSelectedOption = () => {
      if (props.spellingUuid) {
        const relevantForm = props.forms.find(
          form => form.spellingUuid === props.spellingUuid
        );
        selectedOption.value = relevantForm;
      }
    };

    onMounted(() => {
      resetSelectedOption();
    });

    watch(
      () => props.value,
      () => {
        if (props.value) {
          resetSelectedOption();
        }
      }
    );

    return {
      selectedOption,
      setSpelling,
    };
  },
});
